import type { CompleteStoreFragment } from '@drycut/graphql';

import { ActionButtons, Button, Para, Stack } from '@drycut/ui-components';
import { type SubmitHandler, useFormContext, useWatch } from 'react-hook-form';

import type { BookFormValues } from '../..';

import { ControlledNameField } from '../../../ControlledNameField';
import { useBookingContext } from '../../BookingProvider';
import StepContainer from '../../StepContainer';
import CancelButton from '../CancelButton';
import StepWaitingTime from '../StepWaitingTime';
import EditInfoLink from './EditInfoLink';
import ExistingCustomerHeader from './ExistingCustomerHeader';

type Props = {
  onCancel: () => void;
  onNext: () => void;
  onPrevious: () => void;
  store: CompleteStoreFragment;
};

export function NameStep({ store, onPrevious, onNext, onCancel }: Props): React.ReactElement {
  const { watch, setValue, handleSubmit } = useFormContext<BookFormValues>();
  const { manual } = useBookingContext();

  const onSubmit: SubmitHandler<BookFormValues> = () => {
    onNext();
  };

  const existingCustomer = useWatch({ name: 'existingCustomer' });

  return (
    <StepContainer onSubmit={handleSubmit(onSubmit)} store={store}>
      {existingCustomer && (
        <ExistingCustomerHeader
          customerName={watch('name')}
          phoneNumber={watch('phone')}
          onNameClick={() => {
            setValue('existingCustomer', false);
          }}
          onPhoneClick={onPrevious}
        />
      )}

      <StepWaitingTime store={store} />

      {!existingCustomer && (
        <Stack gap={2} className="w-72 self-center">
          <ControlledNameField autoComplete={manual ? 'off' : 'name'} />

          <Para size="sm" className="mt-2">
            Meine Nummer ist nicht{' '}
            <EditInfoLink onClick={onPrevious}>{watch('phone')}</EditInfoLink>
          </Para>
        </Stack>
      )}

      <ActionButtons>
        <Button type="submit">Weiter</Button>
        <CancelButton onCancel={onCancel} />
      </ActionButtons>
    </StepContainer>
  );
}
